<template lang="pug">
Fragment
  .span-full.mt-3
    div.head.d-lg-flex
      .d-flex
        b-icon.no-print.mr-2(icon="tools" variant="dark" font-scale="1.5")
        h4.mb-0.title Repuestos y Mano de Obra
    hr.ot-divider
    b-row.px-3.mt-2
      b-table(responsive hover :items="[  ...ovData.productos, ...ovData.servicios  ]" :fields="fields")
        template(#cell(parte)="{item}")
          b-row(v-if="item.parte")
            span.product-code.pl-3 COD: {{ item.numero_parte || '-' }}
          b-row
            span.product-name.pl-3 {{ item.nombre || '-' }}
        template(#cell(precio_unitario)="{item}")
          div {{ (item.precio_unitario || '0') | formatCurrency }}
        template(#cell(precio_total)="{item}")
          div {{ (item.precio_total || '0') | formatCurrency }}


    //- Total de Tabla de Repuesto y Mano de Obra
    b-row.pt-4.pr-3
      b-col.pl-0(cols="8")
      b-col.pl-0(cols="4")
        b-row.border-top
          b-col
            h4.total-table-label Sub-Total:
          b-col
            h4.total-table-info {{ ovData.monto_total_neto | formatCurrency }}
        b-row.border-top(v-if="ovData.descuento_en_pesos && ovData.descuento_en_pesos > 0")
          b-col
            h4.total-table-label Descuento:
          b-col
            h4.total-table-info -{{ ovData.descuento_en_pesos | formatCurrency }}
        b-row
          b-col
            h4.total-table-label IVA:
          b-col
            h4.total-table-info {{ ovData.iva | formatCurrency }}
        b-row.border-top
          b-col
            h4.total-table-label TOTAL:
          b-col
            h4.total-table-label(style="text-align: end !important")
              | {{ ovData.monto_total_general | formatCurrency }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OVSpareParts',
  data() {
    return {
      fields: [
        { key:'parte' ,label: 'Producto' },
        { key:'cantidad' ,label: 'Cantidad' },
        { key:'precio_unitario' ,label: 'Precio Unitario' },
        { key:'precio_total' ,label: 'Total' },
      ],
    }
  },
  computed: {
    ...mapGetters('OTStore', ['ot']),
    ovData () {
      const ov = this.ot.datos_ov_asociada || {};
      // Se agrega el costo de envio en caso de que exista
      const productBase = ov.detalle_venta || [];
      const products = ov.costo_envio ? [...productBase, {
        precio_unitario: ov.costo_envio,
        precio_total: ov.costo_envio,
        cantidad: 1,
        parte: {
          part_number: 'Costo de Envio',
          description: 'Costo de Envio',
        },
      }] : productBase;

      return {
        monto_total_neto: ov.monto_total_neto || '0',
        iva: ov.valor_iva || Math.floor((Number(ov.monto_total_neto) - (ov.monto_descuento || 0)) * 0.19).toString(),
        monto_total_general: ov.monto_total_final || (Math.floor((Number(ov.monto_total_neto) - (ov.monto_descuento || 0)) * 1.19) + (ov.costo_envio || 0)).toString(),
        productos: products.length > 0
          ? products.map((repuesto) => {
              return {
                ...repuesto,
                numero_parte: repuesto ? repuesto.parte.part_number : '',
                nombre: repuesto.parte ? repuesto.parte.description : '',
              }
            })
          : [],
        rut: ov.rut || '',
        nombre: ov.nombre || '',
        apellido: ov.apellido || '',
        correo_electronico: ov.correo_electronico || '',
        telefono: ov.telefono || '',
        region: ov.region || '',
        comuna: ov.comuna || '',
        direccion: ov.direccion || '',
        comentario: ov.comentario || '-',
        numero_serie_equipo: ov.numero_serie_equipo || '-',
        comentario_cliente: ov.comentario || '-',
        repuestos: ov.repuestos,
        descuento_en_pesos: ov.monto_descuento || '0',
        servicios: ov.servicios.length > 0
          ? ov.servicios.map((s) => {
            return {
              ...s,
              nombre: s.servicio ? s.servicio.nombre || 'servicio_sin_nombre' : 'servicio_sin_nombre',
              precio_unitario: s.precio ?? '0',
              cantidad: s.cantidad || 1,
              precio_total: s.precio ?? '0'
            }
          })
          : []
      }
    },
  },
}
</script>

<style scoped>
.product-code {
  font-size: 11px;
  font-weight: 500;
  color: #525252;
}
.product-name {
  font-size: 14px;
  color: #23201C;
  font-weight: 500;
}
.total-table-label {
  font-size: 14px;
  font-weight: 700;
  text-align: start;
}
.total-table-info {
  font-size: 13px;
  font-weight: 500;
  color: #23201C;
  text-align: end;
}
</style>
